// Title-driven autofill for AMC tests in the test editor.
//
// A title that mentions AMC and a 10 or a 12 anywhere ("AMC 10 TEST 7", "AMC Test 12",
// "2026 AMC 10B") files the test under that type and attaches the AMC scoring profile. When both
// numbers appear, the one right after "AMC" wins, otherwise the first one. A bare "AMC" with no
// number picks nothing: prod has an AMC 10 and an AMC 12 type and no generic one, and which paper
// it is matters to the admins (decided 2026-10-13).
//
// The editor applies this only to a type / profile that is still EMPTY or that this autofill
// itself set — a choice the admin made by hand is never overwritten.

export const amcTypeNameForTitle = (title) => {
    const t = String(title || "");
    // "AMC" as a word, allowing a digit glued on ("AMC10") but not letters ("AMCS").
    if (!/\bAMC(?![A-Z])/i.test(t)) return null;
    // "AMC 10", "AMC-12", "AMC12", "AMC 10B": the number right after AMC, if there is one.
    const adjacent = /\bAMC[\s_-]*(10|12)(?!\d)/i.exec(t);
    // Otherwise any standalone 10 / 12 ("AMC Test 12"); "100" or "2012" never count.
    const anywhere = /(?<!\d)(10|12)(?!\d)/.exec(t);
    const m = adjacent || anywhere;
    return m ? `AMC ${m[1]}` : null;
};

const norm = (s) => String(s || "").replace(/\s+/g, " ").trim().toLowerCase();

// The test-type row the title names, or null.
export const amcTypeForTitle = (title, testTypes) => {
    const want = amcTypeNameForTitle(title);
    if (!want) return null;
    return (testTypes || []).find((t) => norm(t.name) === norm(want)) || null;
};

// The AMC scoring profile: the one that prices answers (metadata.answer_points), not a name match,
// so renaming the profile can't detach it.
export const amcScoringProfile = (profiles) =>
    (profiles || []).find((p) => p?.metadata?.answer_points) || null;
